import { useSyncExternalStore } from "react";

// Minimal `matchMedia` subscription hook (plan 188 W2-M8, task 802) — drives
// the copilot dock's responsive mode switch (docked panel >=1280px, overlay
// drawer below). `useSyncExternalStore` avoids a mount-time flash by reading
// the current match synchronously on both server and client snapshots (no
// SSR in this app, so `getServerSnapshot` just mirrors the client read).
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** The dock's docked-vs-drawer breakpoint (scenario 674/679). */
export const COPILOT_DOCK_BREAKPOINT = "(min-width: 1280px)";
